import {IActivity} from "../../activities/activity";
import {IActivitiesState, IWebsiteActivitiesState} from "../reducers/activities.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getActivitiesState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.activities);

export const getActivities = createSelector(getActivitiesState,
  (state: IActivitiesState): IActivity[] => {
    const activities: IActivity[] = Object.values(state.entities)
      .filter((websiteActivitiesState: IWebsiteActivitiesState): boolean => !!websiteActivitiesState.entities)
      .map((websiteActivitiesState: IWebsiteActivitiesState): IActivity[] => Object.values(websiteActivitiesState.entities))
      .reduce((activities: IActivity[], websiteActivities: IActivity[]): IActivity[] => {
        return activities.concat(websiteActivities);
      }, [])
    .filter((activity: IActivity) => activity.websiteId !== 0)
    return activities;
  }
);

export const getActivitiesLoading = createSelector(getActivitiesState,
  (state: IActivitiesState): boolean =>
    state.loading
);

export const getActivitiesLoaded = createSelector(getActivitiesState,
  (state: IActivitiesState): boolean =>
    state.loaded
);

export const getActivitiesToggled = createSelector(getActivitiesState,
  (state: IActivitiesState): boolean =>
    state.toggled
);
